import React, { useContext } from 'react';
import { A2HSCampaignContextValue } from '../schema/A2HSCampaignProvider.types';

export const A2HSCampaignContext = React.createContext<A2HSCampaignContextValue>(null);

/**
 * Selector function to get A2HSCampaign related data and setters from the context.
 */
export const useA2HSCampaign = () => useContext(A2HSCampaignContext);
